import { Link } from 'react-router-dom';
import { useTrendingHashtags } from '@/hooks/useTrending';
import { formatCount } from '@/lib/format';
import { LoadingSpinner } from '@/components/shared/LoadingSpinner';

export function TrendingHashtags() {
  const { data: hashtags, isLoading, error } = useTrendingHashtags();

  if (isLoading) return <LoadingSpinner />;
  if (error) return <p className="text-error p-4 font-body text-sm">Failed to load trending hashtags</p>;
  if (!hashtags || hashtags.length === 0) {
    return <p className="text-muted p-4 font-body text-sm">No trending hashtags yet</p>;
  }

  return (
    <div className="divide-y divide-border/50">
      {hashtags.map((hashtag, index) => (
        <Link
          key={hashtag.id}
          to={`/hashtag/${hashtag.tag}`}
          className="flex items-center gap-4 px-4 py-3 hover:bg-surface/40 transition-all duration-200 group"
        >
          <span className="text-xs font-display text-dim w-5 text-right">{index + 1}</span>
          <div className="flex-1">
            <span className="font-display font-semibold text-neon group-hover:text-glow transition-all">
              #{hashtag.tag}
            </span>
            <p className="text-xs text-muted mt-0.5 font-body">
              {formatCount(hashtag.recent_count)} posts
            </p>
          </div>
          <div className="w-8 h-8 rounded-lg bg-neon-ghost flex items-center justify-center">
            <span className="text-neon font-display font-bold text-xs">#</span>
          </div>
        </Link>
      ))}
    </div>
  );
}
